import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { const_var, params } from '../../../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {    
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);
    const [offSetHeight, setOffSetHeight] = useState(0);

    const railWidth = 0.2;
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset;
    if(params.leanB_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const trimPosOffset = useMemo(() => {
        if(params.backLeanStoragePosition > 0 && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - 0.2) return railWidth;
        else return 0;
    }, [params.backLeanStoragePosition, params.leanB_p_d, params.add_storage_back])

    const backWallVrTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(params.leanB_p_d / 2 + 0.01), 0);
        model.lineTo(-(params.leanB_p_d / 2 + 0.01), sideWallCloseSize - offSetHeight);
        model.lineTo(-(params.leanB_p_d / 2 - 0.16), sideWallCloseSize - offSetHeight);
        model.lineTo(-(params.leanB_p_d / 2 - 0.16), 0);
        model.closePath();

        return model;
    }, [params.add_storage_check_back, sideWallCloseSize, params.p_b_c_b_b_b, params.add_left_back_lean_porch, params.leanB_p_h, params.leanB_p_d, offSetHeight, params.p_b_c_b_b_l])

    const storageFrontWall = useMemo(() => {
        let wainscot, trim;
        const meshStorageFrontWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanB_p_w)))
        const meshFrontStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanStorageFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModelTwo, extrudeSettings(0.22)));
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))

        let meshStorageFrontWainscotModel_Temp = meshStorageFrontWainscotModel.clone();
        meshStorageFrontWainscotModel_Temp.position.set((params.leanB_p_d / -2  + parseInt(params.add_storage_back) + 0.0025), 3 , 0.07)
        meshStorageFrontWainscotModel_Temp.updateMatrixWorld();

        let meshFrontStorageDelModel_Temp = meshFrontStorageDelModel.clone();
        meshFrontStorageDelModel_Temp.position.set((params.leanB_p_d / -2  + parseInt(params.add_storage_back)) - 0.5, 0, ( params.p_d/2 + params.leanB_p_w + 0.23));
        meshFrontStorageDelModel_Temp.rotation.y = Math.PI/2
        meshFrontStorageDelModel_Temp.updateMatrixWorld();

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos - params.backLeanStoragePosition, 0, -0.7);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshTrimModel_Temp = meshTrimModel.clone();
        meshTrimModel_Temp.position.set(parseInt(params.add_storage_back) + offset - 0.08, 0, -0.01)
        meshTrimModel_Temp.updateMatrixWorld();

        const meshStorageFrontWainscotModel_CSG = CSG.fromMesh(meshStorageFrontWainscotModel_Temp);
        const meshFrontStorageDelModel_CSG = CSG.fromMesh(meshFrontStorageDelModel_Temp);
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);

        const storagefrontWainscotModel_CSG = meshStorageFrontWainscotModel_CSG.subtract(meshFrontStorageDelModel_CSG);
        const SideDelModel_CSG = storagefrontWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

        const CSGStorageFrontWainscotModel = CSG.toMesh(SideDelModel_CSG,new THREE.Matrix4())
        const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());

        wainscot = CSGStorageFrontWainscotModel.geometry;
        trim = meshTrimDelModel.geometry;
    
        return {wainscot, trim}
    }, [params.p_d, params.leanB_p_w, params.leanB_p_d, params.add_storage_back, params.backLeanStoragePosition, const_var.newDoorsArray, params.leanB_p_pos, backWallVrTrimModelTwo])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_l === 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h + 0.05;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_l === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_l;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_b_l, params.leanB_p_h, params.p_r_s])
    

    return (
        <group position={[trimPosOffset, 0, -(params.p_d / 2 + params.leanB_p_w + 0.02 + 0.21)]}>
            {params.p_b_c_b_b_l !== 'Close' &&
                <mesh name="storage-wall-trim" geometry={storageFrontWall.trim}>
                    <MaterialTrim visibleSection={"backLean"} />
                </mesh>
            }

            {params.p_w_c_n == true && storageFrontWall &&
                <mesh name="wainscotTrim" geometry={storageFrontWall.wainscot} position={[offset, 0, 0]} >
                    <MaterialWainScotTrimNew   visibleSection={"backLean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel